import { createBrowserRouter } from "react-router-dom";
import Category from "../components/Category/Category";
import CheckOut from "../components/CheckOut/CheckOut";
import CourseInitial from "../components/CourseInitial/CourseInitial";
import Courses from "../components/Courses/Courses";
import ErrorPage from "../components/ErrorPage/ErrorPage";
import Main from "../layout/Main";
import Blog from "../Pages/Blog/Blog";
import FAQ from "../Pages/FAQ/FAQ";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Shared/Login/Login";
import Register from "../Pages/Shared/Register/Register";
import PrivateRoute from "./PrivateRoute/PrivateRoute";


export const routes = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [
            {
                path: '/',
                element: <Home></Home>,
            },
            {
                path: '/home',
                element: <Home></Home>
            },
            {
                path: ('/category/:id'),
                element: <Category></Category>,
                loader: ({params}) => fetch(`https://b610-learning-platform-server-side-fazaly-fazaly.vercel.app/category/${params.id}`)
            },
            {
                path: ('/courses/:id'),
                element:<Courses></Courses>,
                loader: ({params}) => fetch(`https://b610-learning-platform-server-side-fazaly-fazaly.vercel.app/courses/${params.id}`)
            },
            {
                path: ('/course'),
                element: <CourseInitial></CourseInitial>,
                loader: () => fetch('https://b610-learning-platform-server-side-fazaly-fazaly.vercel.app/courses'),
            },
            {
                path: '/checkout/:id',
                element: <PrivateRoute><CheckOut></CheckOut></PrivateRoute>,
                loader: ({params}) => fetch(`https://b610-learning-platform-server-side-fazaly-fazaly.vercel.app/category/${params.id}`)
                
            },
            {
                path: '/faq',
                element: <FAQ></FAQ>
            },
            {
                path: '/blog',
                element: <Blog></Blog>
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/register',
                element: <Register></Register>
            },
        ]
    }
])